import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../translations';

type PractitionerReceptionServiceRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly receptionServiceName: string;
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
};

export const PractitionerReceptionServiceRemoveConfirmationEventInterceptor = (
   props: PractitionerReceptionServiceRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         modalWidth={ModalWidth.NORMAL}
         testId={'practitionerReceptionServiceRemoveConfirmation'}
         title={receptionServiceTranslationKeys.table.remove.practitioner.confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={
                  props.hasMorePractitioners
                     ? receptionServiceTranslationKeys.table.remove.practitioner.confirmation.content.manyPractitioners
                     : receptionServiceTranslationKeys.table.remove.practitioner.confirmation.content.onePractitioner
               }
               components={{ bold: <strong /> }}
               values={{
                  receptionServiceName: props.receptionServiceName,
                  practitionerName: props.practitionerName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
